export function getTruckingCompanyId() {
  return localStorage.getItem('truckingCompanyId');
}

export function setTruckingCompanyId(company_id: string) {
  localStorage.setItem('truckingCompanyId', company_id);
}
